import React, { useEffect, useState } from "react";
import branding from "../../assets/images/branding.png";
import brandingW from "../../assets/images/branding-w.png";
import { AppContext } from "../../context/AppContext";
import moment from "moment-timezone";
import { formatTextWithFallback } from "../../helpers/helpers";
import { UAParser } from "ua-parser-js";

const Footer = ({ systemInfo }) => {
  const { theme } = React.useContext(AppContext);
  const [browserInfo, setBrowserInfo] = useState(null);
  const [osInfo, setOsInfo] = useState(null);
  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();
    setBrowserInfo(
      `${result.browser?.name} ${
        result.browser?.major ?? result.browser?.version
      }`
    );
    setOsInfo(`${result.os?.name} ${result.os?.version}`);
  }, []);
  return (
    <footer className="page-footer d-sm-block">
      <div className="footer-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-6 m-auto">
              <a
                href="https://vwatch.ai/"
                target="_blank"
                className="btn-link"
                rel="noopener noreferrer"
              >
                <img
                  src={theme === "dark-theme" ? branding : brandingW}
                  alt="v-watch"
                  className="footer-logo"
                />
              </a>
              <ul className="breadcrumb pt-0 pr-0 ">
                <li className="breadcrumb-item mb-0 ">
                  <span className="footer-text">
                    © Copyright {moment().year()} V-Watch
                  </span>{" "}
                </li>
              </ul>
            </div>
            <div className="col-sm-6">
              <ul className="breadcrumb pt-0 pr-0 float-right mt-sm-1">
                <li className="breadcrumb-item mb-0">
                  <p className="details footer-text">
                    {browserInfo ? `Browser: ${browserInfo}` : ""}
                    {osInfo ? `, ${osInfo}` : ""}
                    <span className="d-block">
                      {`Build: ${formatTextWithFallback(
                        systemInfo?.build?.version
                      )}`}
                    </span>
                    <span>{`License Expiry : ${systemInfo?.license?.expiryDate}`}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
